import TooltipItem from './TooltipItem';

export default TooltipItem;
